/**
 * LivePermissionCoach — le guidage de la question du navigateur (`<PermissionPromptCoach>`), branché sur
 * la demande en cours (`usePermissionPrompt`) : dans le live (« Activer mon micro », le micro de la barre,
 * « Réessayer ») et dans la salle d'attente (le test d'entrée). Au web seulement : le moteur ne suit
 * aucune demande dans l'app, où c'est le téléphone qui pose sa question.
 */
import React, { memo } from "react"

import { PermissionPromptCoach } from "../../../../../../design-system/student"
import { pagePermissionBrowser } from "../../../../../../engine/precall/browserPermissionPaths"
import { dismissPermissionPrompt, usePermissionPrompt } from "../../../../../../engine/precall/permissionPrompt"
import { permissionCoachCopy } from "../../../../view-models/student/Live/studentLiveViewModel"

/** Le navigateur, lu une fois : il ne change pas en route. */
const BROWSER = pagePermissionBrowser()

/** Mémoïsé : l'écran qui le monte se redessine souvent (le niveau du micro au test d'entrée, le live). */
export const LivePermissionCoach = memo(function LivePermissionCoach(props: {
    tutorFirstname: string | null | undefined
}) {
    const kind = usePermissionPrompt()
    const copy = permissionCoachCopy(kind ?? "microphone", props.tutorFirstname, BROWSER)
    return (
        <PermissionPromptCoach
            visible={kind != null}
            title={copy.title}
            message={copy.message}
            arrow={copy.arrow}
            okLabel={copy.okLabel}
            onDismiss={dismissPermissionPrompt}
            testID="live-permission-coach"
        />
    )
})
